import { render, staticRenderFns } from "./bestUSAEdit.vue?vue&type=template&id=ff2a1858&"
import script from "./bestUSAEdit.vue?vue&type=script&lang=js&"
export * from "./bestUSAEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports